
// store/index.js
import { createStore } from 'vuex';
import axios from 'axios';

export default createStore({
  state: {
    isLoggedIn: localStorage.getItem('isLoggedIn') === 'true',
    token: localStorage.getItem('access_token') || null,
    error: null, // 新增错误状态
  },
  mutations: {
    setLoggedIn(state, status) {
      state.isLoggedIn = status;
      localStorage.setItem('isLoggedIn', String(status)); // 明确转为字符串
    },
    setToken(state, token) {
      state.token = token;
      localStorage.setItem('access_token', token || ''); // 空值存为 ''
    },
    clearToken(state) {
      state.token = null;
      state.isLoggedIn = false; // 直接同步状态
      localStorage.removeItem('access_token');
      localStorage.removeItem('isLoggedIn');
    },
    setError(state, message) {
      state.error = message; // 新增错误状态更新
    },
  },
  actions: {
    async login({ commit }, credentials) {
      try {
        const response = await axios.post('/api/login', credentials);
        const token = response.data.access_token;
        commit('setToken', token);
        commit('setLoggedIn', true);
      } catch (error) {
        console.error('登录失败:', error);
        commit('clearToken'); // 直接调用 clearToken
        throw error;
      }
    },
    logout({ commit }) {
      commit('clearToken');
    },
    async checkToken({ commit, state }) {
      if (state.token) {
        try {
          const response = await axios.get('/api/validate-token', {
            headers: { 'Authorization': `Bearer ${state.token}` }
          });
          commit('setLoggedIn', response.data.isValid);
          return response.data.isValid; // 返回验证结果
        } catch (error) {
          const message = error.response?.data?.detail || 'Token 验证失败';
          commit('setError', message); // 使用 error 状态
          commit('clearToken');
          return false;
        }
      } else {
        commit('clearToken');
        return false;
      }
    }
  },
  getters: {
    isLoggedIn: state => state.isLoggedIn,
    token: state => state.token,
    error: state => state.error, // 新增错误状态获取
  }
});